import { EmailDraft, EmailRecipient } from '../models/email-draft';

export function emptyEmailDraft(): EmailDraft {
  return { from: null, to: [], cc: [], bcc: [], subject: '', bodyHtml: '' };
}

export function emailKey(email: string): string {
  return email.trim().toLowerCase();
}

export function dedupeRecipients(
  list: readonly EmailRecipient[],
): EmailRecipient[] {
  const seen = new Set<string>();
  const unique: EmailRecipient[] = [];
  for (const recipient of list) {
    const key = emailKey(recipient.email);
    if (!seen.has(key)) {
      seen.add(key);
      unique.push(recipient);
    }
  }
  return unique;
}

export function mergeRecipients(
  current: readonly EmailRecipient[],
  additions: readonly EmailRecipient[],
): EmailRecipient[] {
  return dedupeRecipients([...current, ...additions]);
}

export function sameRecipients(
  left: readonly EmailRecipient[],
  right: readonly EmailRecipient[],
): boolean {
  return (
    left.length === right.length &&
    left.every(
      (item, index) => emailKey(item.email) === emailKey(right[index].email),
    )
  );
}

export function normalizeDraftPatch(
  patch: Partial<EmailDraft>,
): Partial<EmailDraft> {
  const normalized = Object.fromEntries(
    Object.entries(patch).filter(([, value]) => value !== undefined),
  ) as Partial<EmailDraft>;
  for (const field of ['to', 'cc', 'bcc'] as const) {
    const list = normalized[field];
    if (list) {
      normalized[field] = dedupeRecipients(list);
    }
  }
  return normalized;
}
